import ResourceService from '@/api/resource.service';
import configApi from '@/api/config';
import grapePerksAppService from '@/api';

/**
 * sms template service api
 * @class SmsTemplateService
 */
class SmsTemplateService extends ResourceService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.smsTemplates });
  }

  getActiveImport = () => grapePerksAppService.get(
    `${this.baseUrl}/import-from-file/active-import`, { },
  ).then((resp) => resp.data);
}

const singletonInstance = new SmsTemplateService();

/**
 * sms template service api instance
 * @exports api/modules/templates/sms-template
 * */
export default singletonInstance;
